<template>
  <div class="EnterpriseStatistics">
    <div class="index-header">
      <span class="title">
        <i class="el-icon-caret-right"></i>企业诚信统计
      </span>
      <span class="other more" @click="jumpMore">
        更多
        <i class="el-icon-d-arrow-right"></i>
      </span>
    </div>
    <div class="EnterpriseStatistics-main">
      <div class="myChartTotal-father">
        <div class="main-titleText">
          <div>全市企业总数</div>
          <div style="margin-top: 20px;">
            <span class="main-titleNumber" @click="jumpMore()">259</span>
          </div>
        </div>
        <div ref="echarts" id="myChartEnterprise" :style="{width: '350px', height: '150px'}"></div>
      </div>
    </div>
  </div>
</template>

<script>
import commonTitle from '@/assets/js/commonTitle.js';
export default {
  components: {},
  props: {},
  data() {
    return {
      Position: 'running'
    };
  },
  computed: {
    mainTitle: () => {
      return commonTitle;
    }
  },
  created() {},
  mounted() {
    this.drawPie();
  },
  methods: {
    jumpMore() {
      this.$router.push('/intRegList');
    },
    drawPie() {
      //投诉统计
      let myChartEnterprise = this.$echarts.init(this.$refs.echarts);
      var chartName = ['70分以下', '70-89分', '90分以上'];
      var chartData = ['80', '17', '13'];
      var data = [];
      var legendName = [];
      for (var i = 0; i < chartData.length; i++) {
        var c = {
          value: chartData[i],
          name: chartName[i]
        };
        data[i] = c;
        legendName[i] = chartName[i];
      }
      myChartEnterprise.setOption({
        backgroundColor: '#fff',
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {d}% <br/> {c}'
        },
        graphic: {
          elements: [
            {
              type: 'text',
              style: {
                text: '占比',
                x: 100,
                y: 100,
                textAlign: 'center',
                fill: '#333333',
                font: '22px "MicrosoftYaHei", sans-serif '
              },
              left: '26.2%',
              top: 'center'
            }
          ]
        },
        legend: {
          orient: 'vertical',
          x: '60%',
          y: 'center',
          itemWidth: 20,
          itemHeight: 20,
          align: 'left',
          textStyle: {
            fontSize: 14,
            color: '#000'
          },
          data: legendName
        },
        series: [
          {
            type: 'pie',
            radius: ['60%', '80%'],
            center: ['32%', '50%'],
            color: ['#0f77f2', '#67aafe', '#ffb400'],
            data: data,
            labelLine: {
              normal: {
                show: false,
                length: 20,
                length2: 20,
                lineStyle: {
                  color: '#12EABE',
                  width: 2
                }
              }
            },
            label: {
              normal: {
                show: false,
                formatter: '{c|{c}}\n{hr|}\n{d|{d}%}',
                rich: {
                  b: {
                    fontSize: 20,
                    color: '#12EABE',
                    align: 'left',
                    padding: 4
                  },
                  hr: {
                    borderColor: '#12EABE',
                    width: '100%',
                    borderWidth: 2,
                    height: 0
                  },
                  d: {
                    fontSize: 20,
                    color: '#fff',
                    align: 'left',
                    padding: 4
                  },
                  c: {
                    fontSize: 20,
                    color: '#fff',
                    align: 'left',
                    padding: 4
                  }
                }
              }
            }
          }
        ]
      });
    }
  }
};
</script>
<style lang="scss">
@import './css/common.scss';
.EnterpriseStatistics {
  background-color: #fff;
  .EnterpriseStatistics-main {
    overflow: hidden;
    height: 260px;
    .main-titleText {
      display: flex;
      align-items: center;
      height: 50px;
      flex-direction: column;
      div {
        padding: 0 20px;
      }
      .main-titleNumber {
        width: 37px;
        height: 18px;
        font-family: MicrosoftYaHei-Bold;
        font-size: 22px;
        font-weight: bold;
        font-stretch: normal;
        letter-spacing: -1px;
        color: #0f75ef;
        margin-top: 20px;
        cursor: pointer;
      }
    }
    .myChartTotal-father {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 30px;
    }
    .fontSize {
      width: 28px;
      height: 14px;
      font-family: MicrosoftYaHei;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: -1px;
      color: #333333;
    }
  }
}
</style>